<template>
  <div class="content-menu-as">
    <label for="InputPasajeros" class="text-white sr-only">Pasajeros:</label>
    <v-text-field solo readonly>
      <template v-slot:prepend-inner>
        <v-icon @click="popoverShowSelector = !popoverShowSelector" small>
          fas fa-pencil-alt
        </v-icon>
      </template>
      <template v-slot:label>
        <span class="caption">
          {{ msgInput }}
        </span>
      </template>
    </v-text-field>
    <v-menu
      id="pruebaid"
      :content-class="'v-menu-as'"
      v-model="popoverShowSelector"
      :close-on-content-click="false"
      :attach="'.content-menu-as'"
      min-width="320"
    >
      <v-card class="pa-2">
        <v-list>
          <v-list-tile class="mb-2">
            <v-list-tile-content v-if="modHabitacion">
              <v-list-tile-title class="text-xs-center">
                Habitaciones
              </v-list-tile-title>
              <v-list-tile-sub-title class="text-xs-center">
                <v-icon size="15" class="cur-pointer float-left" @click="modificarHabs('r')" color="primary">
                  fas fa-minus-circle
                </v-icon>
                <span>
                  {{ ocupacion.length }}
                </span>
                <v-icon size="15" class="cur-pointer float-right" @click="modificarHabs('s')" color="primary">
                  fas fa-plus-circle
                </v-icon>
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-content v-else>
              <v-list-tile-title class="text-xs-center">
                Pasajeros
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>

        <v-divider class="my-0"></v-divider>
        <v-list v-for="(o, ido) in ocupacion" :key="ido" class="px-5">
          <v-list-tile v-if="modHabitacion">
            <v-list-tile-title class="text-xs-center">Habitacion {{ ido + 1 }}</v-list-tile-title>
          </v-list-tile>
          <v-layout row wrap>
            <v-flex xs6>
              <p class="text-xs-center">
                Adultos
              </p>
              <p class="text-xs-center">
                <v-icon size="15" class="cur-pointer" @click="modificarAdls(ido, 'r')" color="primary">
                  fas fa-minus-circle
                </v-icon>
                <span class="mx-3">
                  {{ o.adultos }}
                </span>
                <v-icon size="15" class="cur-pointer" @click="modificarAdls(ido, 's')" color="primary">
                  fas fa-plus-circle
                </v-icon>
              </p>
            </v-flex>
            <v-flex xs6>
              <p class="text-xs-center">
                Menores
              </p>
              <p class="text-xs-center">
                <v-icon size="15" class="cur-pointer" @click="modificarChds(ido, 'r')" color="primary">
                  fas fa-minus-circle
                </v-icon>
                <span class="mx-3">
                  {{ o.edades.length }}
                </span>
                <v-icon size="15" class="cur-pointer" @click="modificarChds(ido, 's')" color="primary">
                  fas fa-plus-circle
                </v-icon>
              </p>
            </v-flex>
            <v-flex xs12 v-if="o.edades.length > 0">
              <p class="text-xs-center">
                Edades
              </p>
              <v-layout row wrap>
                <v-flex xs6 v-for="(e, ide) in o.edades" :key="ide">
                  <p class="text-xs-center">Edad {{ ide + 1 }}</p>
                  <v-select
                    :id="`edad-${ido}-${ide}`"
                    :items="armarSelectEdades(ido, ide)"
                    @input="updateEdad"
                    solo
                    :value="{ identificador: `${ido}-${ide}`, edad: e.edad }"
                  >
                    <template v-slot:item="data">
                      <small class="text-center">
                        {{ data.item.edad }}
                      </small>
                    </template>
                    <template v-slot:selection="data">
                      <small class="text-center">
                        {{ data.item.edad }}
                      </small>
                    </template>
                  </v-select>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-list>

        <v-card-actions>
          <v-btn color="primary" flat @click="popoverShowSelector = false" block>Listo</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
// @ is an alias to /src
import { debounce } from "debounce"
export default {
  props: ["target", "triggers", "container", "reference", "popoverShow", "ocupacion"],
  name: "selectorOcupacion",
  components: {},
  created() {
    this.cerrarArmar()
  },
  mounted() {
    this.fixPosition()
  },
  methods: {
    cerrarArmar() {
      this.popoverShowSelector = false
      this.armarMensajeInput()
    },
    modificarAdls(indexhab, operacion) {
      this.$store.dispatch("app/actionModificarAld", {
        indice: indexhab,
        operacion: operacion
      })
      this.armarMensajeInput()
    },
    modificarChds(indexhab, operacionchd) {
      this.$store.dispatch("app/actionModificarChds", {
        indice: indexhab,
        operacion: operacionchd
      })
      this.armarMensajeInput()
    },
    modificarHabs(operacionHabs) {
      this.$store.dispatch("app/actionModificarHabs", operacionHabs)
      this.armarMensajeInput()
    },
    modificarEdadChild(indexhab, indexchd, operacion) {
      this.$store.dispatch("app/actionModificarEdadChds", {
        indexhab: indexhab,
        indexchd: indexchd,
        operacion: operacion
      })
      this.armarMensajeInput()
    },
    validMenor(menor) {
      if (menor.edad > 17 || menor.edad < 0) {
        menor.edad = 0
      }
      this.armarMensajeInput()
    },
    updateEdad: debounce(function(identificador, edad) {
      if (identificador.edad < 0 || identificador.edad > 17) {
        identificador.edad = 0
      }
      const splited = identificador.identificador.split("-")
      this.$store.commit("app/setEdadChd", {
        indexhab: splited[0],
        indexchd: splited[1],
        edad: identificador.edad
      })
      this.armarMensajeInput()
    }, 500),
    armarMensajeInput() {
      let arOcupacion = []
      this.ocupacion.forEach(function(element) {
        var adultos = element.adultos + " Adultos"
        var chd = ""
        if (element.edades.length > 0) {
          chd = ", " + element.edades.length + " Menores"
        }
        var todo = adultos.concat(chd)
        arOcupacion.push(todo)
      })
      var string = ""
      arOcupacion.forEach(function(element) {
        string = string.concat(element, " | ")
      })
      this.msgInput = string
    },
    armarSelectEdades(habIndx, edadIndx) {
      const edades = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17]
      let items = []
      edades.forEach(e => {
        items.push({ identificador: `${habIndx}-${edadIndx}`, edad: e })
      })
      return items
    },
    fixPosition() {
      let element = document.getElementsByClassName("v-menu-as")[0]
      element.style.top = "auto"
      element.style.left = "auto"
    }
  },
  data() {
    return {
      popoverShowSelector: false,
      msgInput: null
    }
  },
  computed: {
    modHabitacion: function() {
      if ("cuposAereosSolo" === this.$route.name) {
        return false
      }
      return true
    }
  }
}
</script>
<style scoped>
.centered-input input {
  text-align: center;
}
</style>
